module.exports = __webpack_public_path__ + "img/CUFFMTBI.1035b8a5.jpg";